/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconGenderFemme = createReactComponent("outline", "gender-femme", "IconGenderFemme", [["path", { "d": "M12 9m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0", "key": "svg-0" }], ["path", { "d": "M12 14v7", "key": "svg-1" }], ["path", { "d": "M7 18h10", "key": "svg-2" }]]);

export { IconGenderFemme as default };
//# sourceMappingURL=IconGenderFemme.mjs.map
